module.exports = __webpack_public_path__ + "static/media/giftcard.c8ac3694.svg";